import React, { ReactNode } from "react";

import { useCardContext } from "./card-provider";

type Props = {
  children: ReactNode;
};

export function CardWrapper({ children }: Props) {
  const { useFieldValue } = useCardContext();

  const theme = useFieldValue("theme");
  const layout = useFieldValue("layout");
  const placement = useFieldValue("placement");

  return (
    <div
      className="group/card relative h-full w-full overflow-hidden rounded"
      data-ui={`${theme?.value.toLowerCase()} ${layout?.value.toLowerCase()} ${placement?.value.toLowerCase()}`}
    >
      {children}
    </div>
  );
}
